import React, { FC }             from "react";
import { useDispatch, useStore } from "react-redux";
import { Button, Icon } from "semantic-ui-react";
import RegisterStaff    from "../../../application/usecase/staff/RegisterStaff";
import LoginPassword    from "../../../domain/authentication/LoginPassword";
import Staff            from "../../../domain/staff/Staff";

interface Props {
  password: LoginPassword;
}

const StaffSaveButton: FC<Props> = (props: Props) => {
  const staff: Staff = useStore().getState().staff;
  const registerStaff: RegisterStaff = new RegisterStaff(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => registerStaff.execute(staff, props.password) }
      >
        <Icon name="save"/>保存する
      </Button>
    </>
  );
};

export default StaffSaveButton;
